import { Stack, Typography } from "@mui/material";
import { toast } from "react-toastify";

export async function handleApiError(error: Error, generalMessage: string) {
    let apiError: string | undefined = undefined;
    try {
        // @ts-expect-error Potentially unsafe access
        apiError = error.error?.message ?? JSON.parse(await error.text()).message;
    } catch {
        // Do nothing
    }

    if (apiError == undefined) {
        toast.error(generalMessage);
        console.error(generalMessage, "\r\n", error);
        return;
    }

    console.error(generalMessage, "\r\n", apiError);
    toast.error(
        <Stack spacing={1}>
            <Typography variant={"body1"} fontWeight={"bold"} mb={1}>
                {generalMessage}
            </Typography>
            <Typography variant={"body2"}>{apiError}</Typography>
        </Stack>,
    );
}
